import React from "react";
import LoadingIcon from "../images/loading.gif";

export default function Loader({ loading }) {
  if (!loading) return null;

  return (
    <div role="status" aria-live="polite" aria-label="Chargement">
      <div className="loader-spinner" />
      <img src={LoadingIcon} alt="" className="search-loading hide" />
    </div>
  );
}
